// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kk-G","footer":"styles_footer__3koxi"};